module.exports = __webpack_public_path__ + "static/media/leader_notes.6d2c1d79.pdf";